import { hasPermission } from '../../helpers'
import { useIntl } from 'react-intl'
import {
  SETTINGS_MENU_MESSAGES as M,
  settingsRouteLabel,
  settingsSectionLabel,
} from './settingsMenuMessages'
import { useGetUser } from '../../store/userStore'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ROUTES_SETTINGS } from './routesSetting'

// const ROUTES_LEFT = ROUTES_SETTINGS.filter(({side}) => side === 'left')
// const ROUTES_RIGHT = ROUTES_SETTINGS.filter(({side}) => side === 'right')

export const NavSettingMobile = () => {
  const intl = useIntl()
  const permissions = useGetUser((s) => s.user?.permissions) || []
  const userGroups = useGetUser((s) => s.user?.groups)?.map((g: any) => g.name || g) || []
  const VISIBLE = ROUTES_SETTINGS.filter((r) => {
    if (r.title || !r.route) return true // keep section titles
    const hasPerm = 'perm' in r && r.perm ? hasPermission(permissions, r.perm) : false
    const hasGroup = 'group' in r && r.group ? userGroups.includes(r.group) : false
    const gated = ('perm' in r && r.perm) || ('group' in r && r.group)
    return gated ? hasPerm || hasGroup : true
  })
  return (
    <Dropdown drop='up'>
      <Dropdown.Toggle size='sm' variant='secondary' id='dropdown-basic' className='w-100'>
        {intl.formatMessage(M.myAgency)}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className='w-100 drop-scrollbar'
        style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}
      >
        {VISIBLE.map((info) => {
          if (info.title || !info.route) {
            return (
              <Dropdown.Item key={info.id} className='text-center' style={{ color: '#c4c4c4' }}>
                {settingsSectionLabel(intl, info.title)}
              </Dropdown.Item>
            )
          }
          return (
            <Dropdown.Item
              key={info.id}
              as={Link}
              to={info.route}
              style={{ color: '#133159', marginLeft: info.isChildren ? '8px' : undefined }}
            >
              {settingsRouteLabel(intl, info.route, info.name)}
            </Dropdown.Item>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}
